const PLAN_LABELS = {
  tier_0: 'Free Tier',
  tier_1: 'Tier 1',
  tier_2: 'Tier 2',
  tier_3: 'Tier 3',
  client: 'Client',
  employee: 'Employee'
};

export const planLabel = (planId, fallback) => {
  const id = String(planId || '').trim().toLowerCase();
  const label = String(fallback || '').trim();
  if (id === 'tier_0' || id === 'tier 0' || ['tier_0', 'tier 0'].includes(label.toLowerCase())) {
    return PLAN_LABELS.tier_0;
  }
  return label || PLAN_LABELS[id] || id.replaceAll('_', ' ');
};
